<template>
  <v-autocomplete
    v-if="useAutocomplete"
    :value="value"
    :items="sortedItems"
    :item-text="itemText"
    :item-value="itemValue"
    :label="label"
    :loading="loading"
    :multiple="multiple"
    :chips="multiple"
    :small-chips="multiple"
    :deletable-chips="multiple"
    :search-input.sync="search"
    clearable
    dense
    outlined
    hide-details="auto"
    class="mb-4"
    @input="onInput"
    @focus="onFocus"
  />
  <v-select
    v-else
    :value="value"
    :items="sortedItems"
    :item-text="itemText"
    :item-value="itemValue"
    :label="label"
    :loading="loading"
    :multiple="multiple"
    :chips="multiple"
    :small-chips="multiple"
    :deletable-chips="multiple"
    clearable
    dense
    outlined
    hide-details="auto"
    class="mb-4"
    @input="onInput"
    @focus="onFocus"
  />
</template>

<script>
const AUTOCOMPLETE_THRESHOLD = 20
export default {
  name: 'SmartSelect',
  props: {
    value: {
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
      default: 'label',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    label: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
      needsSort: true,
    }
  },
  computed: {
    useAutocomplete() {
      return this.items.length > AUTOCOMPLETE_THRESHOLD
    },
    selectedValues() {
      if (!this.value) {
        return new Set()
      }
      if (Array.isArray(this.value)) {
        return new Set(this.value)
      }
      return new Set([this.value])
    },
    sortedItems() {
      if (!this.needsSort || this.selectedValues.size === 0) {
        return this.items
      }
      const vf = this.itemValue
      const selected = []
      const rest = []
      for (const item of this.items) {
        const val = typeof item === 'object' ? item[vf] : item
        if (this.selectedValues.has(val)) {
          selected.push(item)
        } else {
          rest.push(item)
        }
      }
      return [...selected, ...rest]
    },
  },
  methods: {
    onInput(val) {
      this.needsSort = false
      this.$emit('input', val)
    },
    onFocus() {
      this.needsSort = true
      this.search = ''
    },
  },
}
</script>
